<template>
  <div class="pos-relative inline-block" v-on-clickaway="close">
    <!-- Dropdown Trigger -->
    <button class="dropup-button" @click="open">{{buttonText}}</button>
    <!-- Dropdown Structure -->
    <transition name="dropup">
      <ul class="dropup-content bg-white large-box-shadow rounded" v-show="show">
        <slot name="list">
          <li>Three</li>
          <li>Two</li>
          <li>One</li>
        </slot>
      </ul>
    </transition>
  </div>
</template>

<script>
  import {mixin as clickaway} from 'vue-clickaway'
  export default {
    mixins: [clickaway],
    props: {
      show: {
        type: Boolean,
        default: false
      },
      buttonText: {
        type: String,
        default: 'Drop Up!'
      }
    },
    exampleData: {
      buttonText: 'Click me!'
    },
    methods: {
      open () {
        this.$emit('open')
      },
      close () {
        this.$emit('close')
      }
    }
  }
</script>

<style>
  .dropup-content {
    margin: 0;
    min-width: 100px;
    max-height: 650px;
    overflow-y: auto;
    position: absolute;
    z-index: 999;
    bottom: 0;
    left: 0;
  }

  .dropup-content li {
    clear: both;
    color: rgba(0, 0, 0, 0.87);
    cursor: pointer;
    min-height: 50px;
    width: 100%;
    text-align: left;
    text-transform: none;
    font-size: 13px;
    font-weight: bold;
    display: block;
    line-height: 22px;
    padding: 14px 16px;
  }

  .dropup-content li:hover {
    background-color: #f6f7f8;
  }

  .dropup-enter-active, .dropup-leave-active {
    transition: all .1s ease;
    transform: scaleY(1);
    transform-origin: bottom;
    overflow: hidden;
  }

  .dropup-enter, .dropup-leave-active {
    transform: scaleY(0);
    opacity: 0;
  }
</style>



// WEBPACK FOOTER //
// DropUp.vue?5af13ef8